import { authApi, type AuthUser } from "@/api/auth";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

type AuthState = {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isInitialized: boolean;
  isLoading: boolean;
  error: string | null;
};

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  isInitialized: false,
  isLoading: false,
  error: null,
};

export const loginThunk = createAsyncThunk(
  "auth/login",
  async (
    payload: { loginId: string; password: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await authApi.login(payload);
      return response.user;
    } catch (error: any) {
      return rejectWithValue({
        status: error?.status,
        message: error?.response?.data?.message || "로그인에 실패했습니다."

      });
    }
  }
);

export const initializeAuthThunk = createAsyncThunk(
  "auth/initialize",
  async (_, { rejectWithValue }) => {
    try {
      const response = await authApi.refresh();
      console.log('response ' , response)
      return response.user;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "세션 초기화에 실패했습니다."
      );
    }
  }
);

export const logoutThunk = createAsyncThunk("auth/logout", async () => {
  await authApi.logout();
});

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearAuthState(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.isInitialized = true;
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginThunk.fulfilled, (state, action) => {
        console.log(action)
        state.isLoading = false;
        state.isInitialized = true;
        state.isAuthenticated = true;
        state.user = action.payload;
        state.error = null;
      })
      .addCase(loginThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.isInitialized = true;
        state.isAuthenticated = false;
        state.user = null;
        state.error = String(action.payload || "로그인에 실패했습니다.");
      })

      .addCase(initializeAuthThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(initializeAuthThunk.fulfilled, (state, action) => {
        console.log(action)
        state.isLoading = false;
        state.isInitialized = true;
        state.isAuthenticated = true;
        state.user = action.payload;
        state.error = null;
      })
      .addCase(initializeAuthThunk.rejected, (state) => {
        state.isLoading = false;
        state.isInitialized = true;
        state.isAuthenticated = false;
        state.user = null;
        state.error = null;
      })

      .addCase(logoutThunk.fulfilled, (state) => {
        state.user = null;
        state.isAuthenticated = false;
        state.isInitialized = true;
        state.isLoading = false;
        state.error = null;
      });
  },
});
const authReducer = authSlice.reducer;
export const { clearAuthState } = authSlice.actions;
export default authReducer